<div class="card mt-3">
  <div class="card-header">
    <h6>Signatures</h6>
  </div>
  <div class="card-body">
    <div class="log-signatures d-flex flex-wrap gap-2">
      <log-signature
        [signature]="signature"
        class="log-signature"
        *ngFor="let signature of visibleSignatures"
      >
      </log-signature>
      <div *ngIf="!visibleSignatures.length">
        <h6>There are not signatures</h6>
      </div>
    </div>
  </div>
</div>
